import * as pageTypes from '../types/Page';
import {INITIAL_STATE} from './state/Page';

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_CUSTOMER_PAGE:
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE:
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE_WITHOUT_CUSTOMER_DATA_CLEAR:
            return { 
                ...state,
                window: "Customer",
                showWindowPicker: true
            };
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_POSITION_PAGE:
            return { 
                ...state,
                window: "ComplaintPosition",
                showWindowPicker: true
            };
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_POSITIONS_PAGE:
            return { 
                ...state,
                window: "ComplaintPositions",
                showWindowPicker: true
            };

        case pageTypes.PAGE_GO_TO_CREATE_SINGLE_COMPLAINT_POSITION_PAGE:
            return { 
                ...state,
                window: "SingleComplaintPosition",
                showWindowPicker: true
            };

        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_POST_ISSUE_PAGE:
            return { 
                ...state,
                window: "IssueComplete",
                showWindowPicker :false
            };
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PREVIEW_PAGE:
            return { 
                ...state,
                window: "Preview",
                showWindowPicker :false
            };
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Page.js